// this file is generated by update_shopify_store_data.py at 2026-06-22 20:31:05.240952
var courses = [
    {
        "course_id": "78C7F81D-F451-F011-999A-005056A7F31D",
        "course_version": 1,
        "name": "Essentials of Pediatric Critical Care Orientation",
        "course_type": 32,
        "author_information": "",
        "description": "Essentials of Pediatric Critical Care Orientation (EPCCO) is a comprehensive orientation program that provides foundational nursing education on pediatric critical care, imparting valuable knowledge and tools needed to care for the most vulnerable children. The content is developed in collaboration with clinical content experts and Pediatric Learning Solutions (a product of Children\u2019s Hospital Association) to advance pediatric nursing education.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5399E302-2F51-F011-9998-005056A730AF",
                "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Curriculum",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "FE47BCD1-E65B-E311-9299-001517135400",
                "course_version": 5,
                "name": "PLS - EPCCO: Trauma: Pediatric Traumatic Brain Injury",
                "course_type": 1,
                "author_information": "",
                "description": "Caring for a child with a traumatic brain injury is rewarding but difficult. It is our responsibility as clinicians to competently and safely care for these children and give them the greatest opportunity to lead a life that is as normal and fulfilling as possible. This course discusses pediatric traumatic brain injury (TBI), focusing on the causes and types of injury, as well as current assessment and management strategies.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the impact of pediatric development and anatomical differences on the incidence of head injury in children.</li>\r\n    <li>Describe the two types of brain injury and list examples of each type.</li>\r\n    <li>Outline assessment strategies for patients with traumatic brain injury.</li>\r\n    <li>Discuss treatment options for patients with traumatic brain injury.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FE3E4FB8-E65B-E311-9299-001517135400",
                "course_version": 6,
                "name": "PLS - EPCCO: Trauma: Pediatric Thoracic Trauma",
                "course_type": 1,
                "author_information": "",
                "description": "Pediatric thoracic trauma requires intense monitoring and diligent clinical management to prevent respiratory compromise, shock and systemic collapse. These injuries are often associated with multi-system trauma.  This course discusses typical mechanisms of injury and appropriate assessment and management strategies for various types of thoracic trauma.\r\n\r\nPhoto courtesy of Corey Schwartz, Phoenix Children\u2019s Hospital, Phoenix, AZ \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe pediatric thoracic anatomy.</li>\r\n    <li>Discuss the mechanisms of thoracic trauma in children and types of injuries that may result.</li>\r\n    <li>Explain the priorities for primary assessment of thoracic trauma injuries.</li>\r\n    <li>Identify thoracic trauma injuries and the signs and symptoms of these injuries.</li>\r\n    <li>Outline the treatment and clinical management steps for specific thoracic injuries.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "52CA6A9B-EF5B-E311-9299-001517135400",
                "course_version": 6,
                "name": "PLS - EPCCO: Cardiovascular Care: Pulmonary Arterial Hypertension",
                "course_type": 1,
                "author_information": "",
                "description": "Pulmonary arterial hypertension (PAH) is a progressive disease that can lead to significant cardiac dysfunction, morbidity and mortality in the pediatric patient. Pulmonary arterial hypertension is often associated with congenital heart disease or an underlying pulmonary disease. For this reason, PAH may affect children at any age.\r\n\r\nWhat will you learn in this course?\r\n\r\nThis course discusses PAH in the pediatric patient, including etiology and pathophysiology, manifestations, diagnosis and current treatment options.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss the etiology and pathophysiology of PAH.</li>\r\n    <li>Identify clinical signs and symptoms of PAH in the pediatric patient.</li>\r\n    <li>Describe clinical management of the child with PAH.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2381A770-8569-DF11-9D81-001517135351",
                "course_version": 8,
                "name": "PLS - EPCCO: Endocrine and Hematology: Diabetes Insipidus and SIADH",
                "course_type": 1,
                "author_information": "",
                "description": "Diabetes insipidus (DI) and syndrome of inappropriate antidiuretic hormone secretion (SIADH) are two endocrine disturbances that, while rare, can have significant life-threatening implications. These conditions, resulting from vastly different causes, affect the fluid and electrolyte (specifically water and sodium) status of the body and the control of antidiuretic hormone. Cerebral salt wasting (CSW) will also be discussed as it causes sodium imbalances and is sometimes difficult to distinguish from SIADH.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the role of antidiuretic hormone in the control of water and sodium balance in the body.</li>\r\n    <li>List the causes of diabetes insipidus (DI), syndrome of inappropriate antidiuretic hormone secretion (SIADH) and cerebral salt wasting (CSW).</li>\r\n    <li>Identify the signs and symptoms of DI, SIADH and CSW.</li>\r\n    <li>Discuss the treatment guidelines for DI, SIADH and CSW.</li>\r\n    <li>Describe potential complications of DI, SIADH and CSW.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8833B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Endocrine Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "528ED2DA-8969-DF11-9D81-001517135351",
                "course_version": 8,
                "name": "PLS - EPCCO: Endocrine and Hematology: Diabetic Ketoacidosis",
                "course_type": 1,
                "author_information": "",
                "description": "Diabetic ketoacidosis (DKA) is a potentially life-threatening metabolic disorder that results from a dangerously insufficient amount of insulin in the body, which leads to the breakdown of fat to use as fuel for the body. When this happens, a buildup of acid (or ketones) accumulates in the body, eventually leading to ketoacidosis if left untreated. This course will review the pathophysiology of DKA, as well as clinical presentation, metabolic disturbances, interventions, and ongoing care for the pediatric patient.\r\n\r\nPrevalence DKA is present at the time of diagnosis in up to one-fourth of children with Type 1 diabetes. While the pediatric mortality rate for DKA is approximately 15 to 30%, secondary complications related to DKA account for 60 to 90% percent of deaths, with children under the age of 5 being at highest risk for mortality.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Explain the pathophysiology and etiology of diabetic ketoacidosis (DKA).</li>\r\n    <li>Describe typical electrolyte disturbances that are associated with DKA.</li>\r\n    <li>Identify the signs and symptoms of DKA.</li>\r\n    <li>Discuss treatment priorities and interventions for DKA.</li>\r\n    <li>Outline the complications of DKA.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8833B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Endocrine Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4F2C51E4-846C-DF11-91E1-001517135511",
                "course_version": 10,
                "name": "PLS - EPCCO: Trauma: Pediatric Spinal Column/Cord Injuries",
                "course_type": 1,
                "author_information": "",
                "description": "Traumatic spinal injuries, although not as common as other types of trauma injuries, carry the potential for significant and permanent life-changing consequences. Whether spinal trauma results in a permanent or temporary disability, the physical, emotional and social adaptations that occur during the recovery period present unique challenges to the child, the family and the staff members who care for these children.\r\n\r\nWhat will you learn in this course?\r\n\r\nThis course reviews the following topics related to pediatric spinal cord injuries:\r\nPediatric spinal anatomy\r\nMechanisms of injury and specific injuries that occur\r\nClinical management during the initial trauma period\r\nPrevention and management of long-term complications\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss the anatomy of the pediatric spine and nervous system.</li>\r\n    <li>Describe mechanisms of spinal injury including differences related to age.</li>\r\n    <li>Explain key characteristics of each type of spinal injury.</li>\r\n    <li>Summarize the elements of a comprehensive neurological assessment.</li>\r\n    <li>Describe the primary assessment, immobilization and management priorities for spinal injury.</li>\r\n    <li>Discuss the common secondary complications of spinal injury and the related management strategies.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B911FA19-746C-DF11-91E1-001517135511",
                "course_version": 8,
                "name": "PLS - EPCCO: Patient Care: Nutrition in the Critically Ill Child",
                "course_type": 1,
                "author_information": "",
                "description": "Effective nutrition support therapy improves wound healing, decreases catabolic response to injury (minimizing loss of protein) improves gastrointestinal structure and function, and reduces the risk of infection. This course discusses the nutritional needs of the critically ill child, including the impact of acute illness on a child\u2019s nutritional status and needs, assessment parameters, and strategies to support the critically ill child\u2019s caloric and metabolic requirements.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define the two physiologic phases that occur in response to injury or acute illness.</li>\r\n    <li>Explain the major components of a nutritional assessment.</li>\r\n    <li>Discuss the concepts and complications of underfeeding and overfeeding.</li>\r\n    <li>Explain the advantages, routes, components, potential complications and nursing considerations related to enteral nutrition.</li>\r\n    <li>Identify and discuss the indications, components, routes, potential complications and nursing responsibilities related to parenteral nutrition.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B6523F50-806C-DF11-91E1-001517135511",
                "course_version": 9,
                "name": "PLS - EPCCO: Trauma: Pediatric Orthopedic Trauma",
                "course_type": 1,
                "author_information": "",
                "description": "Trauma is the number one cause of morbidity and mortality in the pediatric population, with injuries ranging from mild to life-threatening. Orthopedic trauma diagnosis and management can be challenging in the pediatric population. Future bone growth potential has the biggest impact on treatment choices for pediatric patients versus adult patients.  \r\n\r\nThis course provides an overview of the types of orthopedic injuries in children and includes a discussion of the risk factors, assessment parameters, priorities of care, management goals and strategies and injury prevention education for patients and families.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the differences between the child and adult musculoskeletal systems.</li>\r\n    <li>Describe the types of traumatic orthopedic injuries most commonly suffered by children.</li>\r\n    <li>Recognize potential life-threatening orthopedic injuries.</li>\r\n    <li>Explain the assessment parameters and management goals specific to pediatric orthopedic injuries.</li>\r\n    <li>Describe strategies to prevent orthopedic injuries in the pediatric population.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "A6CFAE6D-916C-DF11-91E1-001517135511",
                "course_version": 8,
                "name": "PLS - EPCCO: Trauma: Pediatric Toxicology Exposure",
                "course_type": 1,
                "author_information": "",
                "description": "Unintentional and intentional exposures to toxic substances continue to be a significant cause of morbidity and mortality in the US. Children younger than six years continue to account for the majority of all human exposures. This course discusses toxic exposures as it pertains to children, including common routes and substances, risk factors, assessment and management of exposure incidences, and prevention strategies.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss the most common types of exposures, routes and substances of pediatric toxic exposures.</li>\r\n    <li>Describe appropriate stabilization and assessment of patients with suspected or known toxic exposure.</li>\r\n    <li>Recognize toxic syndromes and correlate to the specific class of toxin.</li>\r\n    <li>Explain current management strategies for toxic exposures, including the goals and specific interventions.</li>\r\n    <li>Describe toxic exposure prevention strategies to discuss with parents and caregivers.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D54A0C4C-766C-DF11-91E1-001517135511",
                "course_version": 9,
                "name": "PLS - EPCCO: Trauma: Pediatric Abdominal Trauma",
                "course_type": 1,
                "author_information": "",
                "description": "Pediatric abdominal trauma is the third leading cause of trauma-related death (after head and thoracic injury) in children. Abdominal trauma can also lead to significant morbidity in the pediatric population. These children are often very ill, requiring intensively skilled clinical care and management. This course discusses the anatomical factors that predispose children to abdominal trauma, likely causes of abdominal trauma, the most common injuries and clinical assessment and management.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the anatomical factors that increase the risk of abdominal trauma in the child.</li>\r\n    <li>Explain the most common mechanism of injury and recall two types of resulting abdominal injuries.</li>\r\n    <li>Describe the primary survey of the child with abdominal trauma.</li>\r\n    <li>List the various types of abdominal injuries and describe the signs and symptoms of these injuries.</li>\r\n    <li>Outline the clinical management of specific abdominal trauma injuries.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DA77784A-6D69-DF11-A530-0015171C1A75",
                "course_version": 9,
                "name": "PLS - EPCCO: Patient Care: Assessment of the Critically Ill Child",
                "course_type": 1,
                "author_information": "",
                "description": "This course discusses the criteria and methodology for performing an efficient, yet thorough assessment of the critically ill child. Patient prioritization is also reviewed. The course includes case scenarios in which learners can apply their patient prioritization and assessment knowledge.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p abp=\"1504\">At the conclusion, participants should be able to: </p>\r\n<ul>\r\n    <li abp=\"1504\">Explain the criteria for performing an effective assessment of the critically ill child.</li>\r\n    <li abp=\"1504\">Describe the exam components of a rapid, yet thorough assessment of the critically ill child.</li>\r\n    <li abp=\"1504\">Prioritize a patient assignment and identify the key parameters to assess in the prioritized patient.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C577E26B-3E6A-DF11-A530-0015171C1A75",
                "course_version": 9,
                "name": "PLS - EPCCO: Neurology/Neurosurgery: Meningitis and Encephalitis",
                "course_type": 1,
                "author_information": "",
                "description": "Meningitis and encephalitis are the two most common central nervous system (CNS) infections in the pediatric population. They can lead to permanent neurologic damage or even death. Prompt recognition and intervention are crucial to ensure an optimal outcome.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the etiology of meningitis and encephalitis.</li>\r\n    <li>Describe the manifestations of meningitis and encephalitis.</li>\r\n    <li>Discuss the methods for diagnosing central nervous system infections in the pediatric and neonatal patient.</li>\r\n    <li>Explain the strategies for managing meningitis and encephalitis.</li>\r\n    <li>Describe the methods of preventing infections of the central nervous system.</li>\r\n    <li>Discuss the potential complications of meningitis and encephalitis.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3ED2A771-5F69-DF11-A530-0015171C1A75",
                "course_version": 9,
                "name": "PLS - EPCCO: Cardiovascular Care: Acquired Heart Disease in Children",
                "course_type": 1,
                "author_information": "",
                "description": "Acquired heart diseases can develop any time after birth and may be caused by a variety of factors, including infection, genetics, the environment or autoimmune disorders. Often the cause of acquired heart disease is unknown.  Acquired heart disease can lead to profound congestive heart failure, signs of decreased cardiac output, myocardial ischemia and even sudden death. The manifestations and possible negative outcomes from these diseases require early recognition and intervention.  \r\n\r\nThis module discusses two of the most common acquired heart diseases in children: Myocarditis, Cardiomyopathy            \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li> Compare and contrast the etiology and pathology of myocarditis, dilated cardiomyopathy and hypertrophic cardiomyopathy.</li>\r\n    <li>Identify the clinical manifestations of myocarditis and cardiomyopathy in children.</li>\r\n    <li>Describe the management of myocarditis and cardiomyopathy in children.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BCEF821C-E45B-E311-80E3-0015171C1A75",
                "course_version": 5,
                "name": "PLS - EPCCO: Cardiovascular Care: CHD: Decreased Systemic Blood Flow",
                "course_type": 1,
                "author_information": "",
                "description": "Congenital heart defects range from simple to complex. They are classified according to the type of blood flow created by the defect. In this course we will discuss defects that create decreased systemic blood flow.\r\n\r\nWhat will you learn in this course?\r\n\r\nThis course introduces structural and hemodynamic characteristics, manifestations and current treatment options associated with the following defects:\r\n\r\nCoarctation of the Aorta (COA)\r\nAortic Stenosis (AS)\r\nHypoplastic Left Heart Syndrome (HLHS)\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify congenital heart defects that cause a decrease in systemic blood flow.</li>\r\n    <li>Differentiate the structure and hemodynamic characteristics of each defect.</li>\r\n    <li>Compare and contrast the clinical manifestations and diagnosis of each defect.</li>\r\n    <li>Outline the management strategies for each defect.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiac Disorders",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.00] [CNE (JAICE) Credits: 1.00] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D9BEEAF5-E35B-E311-80E3-0015171C1A75",
                "course_version": 6,
                "name": "PLS - EPCCO: Cardiovascular Care: Caring for the Pediatric Patient in Shock",
                "course_type": 1,
                "author_information": "",
                "description": "Shock is a complex process characterized by decreased tissue perfusion resulting in an inadequate supply of oxygen and nutrients to cells. Many hospitalized children may be at risk for developing shock. Because children have strong compensatory mechanisms, hypotension is often a late and ominous sign of shock. Consequently, clinicians must be able to recognize the pediatric patient at risk for development of shock, differentiate the various types of shock and their associated clinical indicators, and utilize current clinical guidelines to manage the identified shock state.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Recognize and differentiate obstructive, cardiogenic, hypovolemic and distributive shock.</li>\r\n    <li>Explain the management strategies for each type of shock.</li>\r\n    <li>Follow the pediatric-specific national guidelines for septic shock management.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]<span style=\"white-space:pre;\">\t</span>",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E4871402-E45B-E311-80E3-0015171C1A75",
                "course_version": 5,
                "name": "PLS - EPCCO: Cardiovascular Care: CHD: Increased Pulmonary Blood Flow",
                "course_type": 1,
                "author_information": "",
                "description": "Congenital heart defects range from simple to complex. They are classified according to the type of blood flow created by the defect. In this course we will discuss defects that create increased pulmonary blood flow.         \r\n\r\nWhat will you learn in this course?\r\n\r\nThis course introduces structural and hemodynamic characteristics, manifestations and current treatment options associated with the following defects:\r\n\r\nPatent Ductus Arteriosus (PDA)\r\nAtrial Septal Defect (ASD)\r\nVentricular Septal Defect (VSD)\r\nAtrioventricular Septal Defect (AVSD)\r\nTotal Anomalous Pulmonary Venous Return (TAPVR)\r\nTruncus Arteriosus\r\nTransposition of the Great Arteries (TGA)\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.25] [CNE (JAICE) Credits: 1.25] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify congenital heart defects that cause an increase in pulmonary blood flow.</li>\r\n    <li>Differentiate the structure and hemodynamic characteristics of each defect.</li>\r\n    <li>Compare and contrast the clinical manifestations and diagnosis of each defect.</li>\r\n    <li>Outline the management strategies for each defect.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiac Disorders",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 1.25] [CNE (JAICE) Credits: 1.25] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4638C60E-E45B-E311-80E3-0015171C1A75",
                "course_version": 5,
                "name": "PLS - EPCCO: Cardiovascular Care: CHD: An Overview",
                "course_type": 1,
                "author_information": "",
                "description": "The term congenital heart disease (CHD) describes a diverse group of heart defects present at birth. Many of these defects go unrecognized, while others lead to significant problems soon after birth. Some defects can be managed with medication, some will require surgery, and others may lead to death.\r\n\r\nThis course provides an overview of the embryology and fetal and normal circulation, as well as general diagnostic procedures and post-operative care of infants diagnosed with a congenital heart defect.   \r\n\r\nAdditional Pediatric Learning Solutions courses* you may find helpful:\r\nCHD: Increased Pulmonary Blood Flow\r\nCHD: Decreased Pulmonary Blood Flow\r\nCHD: Decreased Systemic Blood Flow   \r\n\r\n*Note: These courses may not be currently available in your organization.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the potential risk factors of congenital heart disease.</li>\r\n    <li>Summarize the components of fetal circulation that change at delivery.</li>\r\n    <li>Recognize the normal hemodynamics of postnatal cardiac circulation.</li>\r\n    <li>Discuss diagnostic procedures and post-operative complications associated with congenital heart disease.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiac Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.50] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "682BA8AB-EB5B-E311-80E3-0015171C1A75",
                "course_version": 5,
                "name": "PLS - EPCCO: Neurology/Neurosurgery: Craniotomy",
                "course_type": 1,
                "author_information": "",
                "description": "The care of children requiring craniotomies centers around astute assessment skills and basic principles of neurological clinical management. The implementation of appropriate interventions in the immediate post-operative and recovery period will provide the child with the best chance for neurologic improvement and effective rehabilitation.\r\n\r\nThis course discusses the common indications for craniotomy, various approaches to surgery, potential postoperative complications and clinical management during the recovery period.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss the indications for a craniotomy in the pediatric patient.</li>\r\n    <li>Outline the operative details that influence post-craniotomy assessment and management.</li>\r\n    <li>Recognize complications that might occur post-operatively following a craniotomy.</li>\r\n    <li>Implement clinical interventions that will improve patient outcomes after surgery.</li>\r\n    <li>Outline key discussion points that should be included in family craniotomy-related discharge education.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "471DBAB7-EB5B-E311-80E3-0015171C1A75",
                "course_version": 5,
                "name": "PLS - EPCCO: Renal Care: Hemodialysis",
                "course_type": 1,
                "author_information": "",
                "description": "When the kidneys are no longer able to perform their critical blood-cleansing function, a temporary or permanent means of ridding the body of wastes and toxins must be established. There are currently two methods of meeting this requirement: renal replacement therapy or renal transplant.   What will you learn in this course?   \r\n\r\nThis course addresses \r\nOne type of renal replacement therapy, hemodialysis \r\nAn overview of the causes of renal failure in the neonatal and pediatric population \r\nThe role of hemodialysis in controlling kidney failure and maintaining homeostasis \r\nThe administration and procedural guidelines for the safe provision of hemodialysis \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the process of hemodialysis and relate its function in sustaining life.</li>\r\n    <li>Discuss the importance of a functional arteriovenous access, the types of access devices and their care considerations.</li>\r\n    <li>Outline patient assessment data necessary for the initiation of hemodialysis treatment.</li>\r\n    <li>Examine possible complications of hemodialysis therapy.</li>\r\n    <li>Evaluate fluid and dietary restrictions of the renal patient.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "123FA2FE-A799-DF11-B74C-0015171C5BB1",
                "course_version": 8,
                "name": "PLS - EPCCO: Cardiovascular Care: Congestive Heart Failure",
                "course_type": 1,
                "author_information": "",
                "description": "Children with congestive heart failure (CHF) often present to the hospital acutely ill. CHF is a complex problem requiring a thorough understanding of cardiopulmonary anatomy and physiology. This course discusses the pathophysiology, manifestations and treatment options for children with congestive heart failure.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the pathophysiology of congestive heart failure in the pediatric patient.</li>\r\n    <li>Differentiate between acute and chronic heart failure.</li>\r\n    <li>Identify manifestations of heart failure in the pediatric patient.</li>\r\n    <li>Discuss management of heart failure in the pediatric patient.</li>\r\n    <li>Recognize the role of nutrition in the management of the pediatric patient.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiac Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "CFCC5D8D-8C6C-DF11-B520-0015171C5BB3",
                "course_version": 8,
                "name": "PLS - EPCCO: Patient Care: Sedation and Analgesia in the ICU",
                "course_type": 1,
                "author_information": "",
                "description": "Critically ill patients undergo various therapies and procedures, further heightening their stress response, for which sedation and analgesia are frequently required. This course specifically discusses the use of sedatives and analgesia in the intensive care unit (ICU). This course will also discuss delirium assessment, prevention and treatment.\r\n\r\nAdditional Courses\r\n\r\nFor a more comprehensive review of pain assessment and management, see Pediatric Learning Solutions\u2019 *Pain Management course series. \r\n\r\n*Note: This module may not be currently available in your organization.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify and differentiate the various agents used for sedation and analgesia in the ICU, including when to use.</li>\r\n    <li>Describe how to appropriately monitor patients who require sedation and analgesia.</li>\r\n    <li>Define pain and describe a two-step approach to pain management.</li>\r\n    <li>Define delirium and describe prevention and treatment.</li>\r\n    <li>Describe symptoms of withdrawal and identify appropriate medications and strategies used in the prevention and management of withdrawal.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "30A70684-946C-DF11-B520-0015171C5BB3",
                "course_version": 9,
                "name": "PLS - EPCCO: Cardiovascular Care: Vasoactive Medications",
                "course_type": 1,
                "author_information": "",
                "description": "Critically ill children may require resuscitation and/or support of their cardiovascular system. Vasoactive medications play a significant and life-sustaining role in the treatment of these children.\r\n\r\nThis course provides an overview of the various vasoactive agents and their effects.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify vasoactive medications used in critically ill children.</li>\r\n    <li>Recognize the physiologic effects of stimulating the alpha- and beta-adrenergic receptors, as well as the vasopressin and dopamine receptors.</li>\r\n    <li>Describe the characteristics of inotropic, vasopressor, and vasodilator medications including their indications for use, dosage, adverse reactions, and administration.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E702D6F2-2AA6-DF11-B882-0015171C5BB3",
                "course_version": 11,
                "name": "PLS - EPCCO: Pulmonary Care: Acute Respiratory Distress Syndrome",
                "course_type": 1,
                "author_information": "",
                "description": "Pediatric acute respiratory distress syndrome (PARDS) is a life-threatening condition that results from either direct  injury to the lungs or as a systemic response to an indirect injury. In PARDS, fluid accumulates in the alveoli, preventing proper gas exchange. This can lead to a sequelae of events affecting the body as a whole.                                                                                   PARDS occurs in 15 to 18 percent of all ventilated patients and approximately one percent of children admitted to PICU.\r\n\r\nThe mortality rate ranges from 20 to 45 percent.\r\n\r\nThis course provides an overview of PARDS and discusses current management standards. \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p abp=\"1506\">At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li abp=\"1506\">Define PARDS using the criteria of the Pediatric Acute Lung Injury Consensus Conference.</li>\r\n    <li abp=\"1506\">Associate the pathophysiology of PARDS to its clinical presentation.</li>\r\n    <li abp=\"1506\">Recognize the presenting clinical features of PARDS.</li>\r\n    <li abp=\"1506\">Outline current treatment and management modalities for PARDS.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1FE4666D-326A-DF11-B520-0015171C5BB3",
                "course_version": 9,
                "name": "PLS - EPCCO: Pulmonary Care: Mechanical Ventilation: Introduction to Pediatric Practices",
                "course_type": 1,
                "author_information": "",
                "description": "Care of the pediatric patient requiring mechanical ventilation requires a thorough understanding of the principles of ventilatory support and in-depth clinical assessment and management skills. Because these patients are often critically ill and have complex needs, the clinician plays a crucial role in providing efficient, effective and holistic care to ensure positive patient outcomes. This course introduces the principles and current pediatric modes of mechanical ventilation.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the parameters of mechanical ventilation and how each can be manipulated to improve oxygenation and lung mechanics.</li>\r\n    <li>Describe methods and modes of mechanical ventilation.</li>\r\n    <li>Explain patient assessment criteria and equipment assessment steps to evaluate the effectiveness of mechanical ventilation, including assessment indicators for weaning and extubation readiness.</li>\r\n    <li>Evaluate the role of nitric oxide, surfactant, patient position changes and heliox as adjunct therapies to mechanical ventilation.</li>\r\n    <li>Identify complications of mechanical ventilation.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F84151B6-976C-DF11-B520-0015171C5BB3",
                "course_version": 8,
                "name": "PLS - EPCCO: Pulmonary Care: Preventing Ventilator-Associated Pneumonia",
                "course_type": 1,
                "author_information": "",
                "description": "Though an essential, life-saving intervention for patients of all ages, mechanical ventilation poses risks for various complications, referred to as ventilator-associated events (VAEs). One such complication is pneumonia. Ventilator-associated pneumonia (VAP), deemed a preventable complication, carries a high mortality rate and prolongs both time in the intensive care unit and overall hospital length of stay. It also carries a significant financial burden.          \r\n\r\nThis course provides an overview of VAP incidence and causative agents. There is a detailed discussion of pediatric-specific, evidence-based practices for prevention in the neonatal and pediatric intensive care units.  \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define ventilator-associated pneumonia (VAP).</li>\r\n    <li>Outline the criteria for diagnosis of VAP.</li>\r\n    <li>Outline the associated risk factors for development of VAP in the pediatric population.</li>\r\n    <li>Summarize the evidence-based practice standards for the prevention of VAP.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FE6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physical Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "96277191-1B6A-DF11-93F1-00188B39EB5C",
                "course_version": 8,
                "name": "PLS - EPCCO: Cardiovascular Care: Hemodynamic Monitoring",
                "course_type": 1,
                "author_information": "",
                "description": "Critically ill children frequently experience variations and fluctuations in vascular pressures that may precede or accompany the development of life-threatening crises. Hemodynamic monitoring allows for changes in a critically ill child\u2019s condition to be assessed rapidly and for the early initiation of interventions to restore normal physiological functioning. This course will address the background anatomy and physiology of the circulatory system as it relates to hemodynamic monitoring, indications for use, an introduction to the system components, normal values for hemodynamic monitoring and specific care and troubleshooting aspects of four monitoring systems: intra-arterial, central venous, pulmonary artery and left atrial.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss the circulatory system and its pressure gradients as they relate to hemodynamic monitoring.</li>\r\n    <li>Identify the components of the pressure monitoring system and describe their functions.</li>\r\n    <li>Explain the purpose and methodology of calibrating the pressure monitoring system.</li>\r\n    <li>Explain the indications, insertion sites, normal values, causes and troubleshooting considerations of abnormal values and waveforms, and potential complications for intra-arterial blood pressure monitoring, central venous pressure monitoring, PA monitoring and LA monitoring.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DFE93A3D-7469-DF11-93F1-00188B39EB5C",
                "course_version": 8,
                "name": "PLS - EPCCO: Neurology/Neurosurgery: Hydrocephalus",
                "course_type": 1,
                "author_information": "",
                "description": "Hydrocephalus is a pathological condition caused by an abnormal accumulation of cerebrospinal fluid (CSF) in the ventricles of the brain. Inadequate treatment of hydrocephalus can result in further brain injury and sometimes even death. For some children, hydrocephalus can be managed by placing a ventriculoperitoneal (VP) shunt to drain the excess fluid. A properly working shunt should reduce further brain injury from intracranial hypertension.\r\n\r\nHydrocephalus requires astute assessment and appropriate treatment to save the child\u2019s life. This course discusses the clinical aspects and assessment skills necessary to identify and manage both the acute and chronic phases of hydrocephalus.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Verbalize the causes and pathophysiology of hydrocephalus.</li>\r\n    <li>Differentiate between obstructive and communicating hydrocephalus.</li>\r\n    <li>Describe the clinical manifestations and methods of diagnosis of hydrocephalus.</li>\r\n    <li>Outline the acute and chronic management of hydrocephalus.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "835A4815-1A6A-DF11-93F1-00188B39EB5C",
                "course_version": 8,
                "name": "PLS - EPCCO: Patient Care: Family-Centered Care in the ICU",
                "course_type": 1,
                "author_information": "",
                "description": "The admission of a child to the critical care setting is a traumatic and stressful event for the entire family. By recognizing the typical stressors experienced by pediatric patients and their families and employing appropriate patient- and family-centered interventions, the clinician can help families cope and achieve greater patient and family satisfaction.\r\n\r\nWhat will you learn in this course?\r\n\r\nThis course discusses the core principles of providing patient- and family-centered care to the critically ill child and family.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00] [PDU Credits: 0.50]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define patient- and family-centered care.</li>\r\n    <li>Explain the core principles of patient- and family-centered care.</li>\r\n    <li>Identify major sources and symptoms of stress for critically ill children and their families.</li>\r\n    <li>Describe interventions to support families in crisis.</li>\r\n    <li>Select appropriate strategies to facilitate a positive sibling visit.</li>\r\n    <li>Discuss factors that would lead to the involvement of a social worker.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00] [PDU Credits: 0.50]",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E6705D78-7869-DF11-93F1-00188B39EB5C",
                "course_version": 10,
                "name": "PLS - EPCCO: Neurology/Neurosurgery: Intracranial Pressure Monitoring and Management",
                "course_type": 1,
                "author_information": "",
                "description": "There are many conditions, illnesses and injuries that can result in a condition known as intracranial hypertension (IH), which is characterized by elevated intracranial pressure (ICP). These causes can be either congenital or acquired.  Symptoms of elevated ICP may include headaches, nausea/vomiting, sensory changes, seizures and altered mental status. Early recognition of these symptoms and prompt diagnosis are essential for initiating critical interventions.\r\n\r\nAstute monitoring and management of ICP is crucial. Failure to address the condition can lead to severe neurological injury and potentially death.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the physiologic process of autoregulation and accommodation in controlling intracranial pressure.</li>\r\n    <li>Discuss specific conditions and situations that require intracranial pressure monitoring.</li>\r\n    <li>Describe the invasive intracranial pressure monitoring system and goal of therapy.</li>\r\n    <li>Discuss several methods of managing intracranial pressure by modifying the blood, brain and cerebrospinal fluid components.</li>\r\n    <li>Describe bedside care of the external ventriculostomy device.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00]",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "44CBDCC9-7D69-DF11-93F1-00188B39EB5C",
                "course_version": 10,
                "name": "PLS - EPCCO: Pulmonary Care: Introduction to Arterial Blood Gas Interpretation",
                "course_type": 1,
                "author_information": "",
                "description": "Proper recognition and management of alterations in respiratory or metabolic status is fundamental when caring for the pediatric patient. Blood gases provide insights into the functioning of the respiratory system and the metabolic system. Accurate interpretation of blood gas results is essential for the diagnosis and management of pediatric patients, resulting in improved outcomes.\r\n\r\nThis course discusses and provides a methodology by which to assess and interpret blood gas values.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the normal values for each of the following&nbsp; arterial blood gas components: pH, PaCO 2 , HCO 3 -, base excess.</li>\r\n    <li>Analyze a blood gas to determine the acid-base balance, ventilation and oxygenation status.</li>\r\n    <li>Differentiate compensated, uncompensated and partially compensated states of acid-base balance.</li>\r\n    <li>Distinguish respiratory acidosis, respiratory alkalosis, metabolic acidosis and metabolic alkalosis.</li>\r\n    <li>Identify common causes of sampling errors in arterial blood gas collection.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "ECE70074-9B26-F011-999B-005056A773F1",
                "course_version": 1,
                "name": "PLS - EPCCO: Cardiovascular Care: CHD: Decreased Pulmonary Blood Flow",
                "course_type": 1,
                "author_information": "",
                "description": "Congenital heart defects range from simple to complex. They are classified according to the type of blood flow created by the defect. In this course we will discuss defects that create decreased pulmonary blood flow.\r\n\r\nWhat will you learn in this course?\r\n\r\nThis course introduces structural and hemodynamic characteristics, manifestations and current treatment options associated with the following defects:\r\n\r\nPulmonary Stenosis\r\nTetralogy of Fallot (TOF)\r\nTricuspid Atresia\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify congenital heart defects that cause a decrease in pulmonary blood flow.</li>\r\n    <li>Differentiate the structure and hemodynamic characteristics of each defect.</li>\r\n    <li>Compare and contrast the clinical manifestations and diagnosis of each defect.</li>\r\n    <li>Outline the management strategies for each defect.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CME (JAICE) Credits: 0.75] [CNE (JAICE) Credits: 0.75] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "AF6BCCE6-37A3-E911-AB90-005056B16BE3",
                "course_version": 3,
                "name": "PLS - EPCCO: Pulmonary Care: Status Asthmaticus",
                "course_type": 1,
                "author_information": "",
                "description": "Asthma is the most common chronic illness in childhood and a leading cause of hospitalization. The incidence of asthma in the pediatric population has increased in the past 30 years. While the severity of the disease varies from mild to severe, all patients with asthma are at risk for developing status asthmaticus. Recognizing when manifestations are indicative of worsening asthma or when a patient is not responding to therapy allows the clinician to intervene sooner.        \r\n\r\nSome of the foundational content in this course is a review from our Asthma course.  \r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00] [CRCE Credits: 1.00]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Review the respiratory system and pathophysiology of asthma, including risk factors, patient assessment, key indicators and asthma classification.</li>\r\n    <li>Recognize the presenting signs and symptoms of a severe asthma exacerbation in the pediatric patient.</li>\r\n    <li>Use an evidence-based clinical scoring system to assess the severity of an asthma exacerbation and response to therapy.</li>\r\n    <li>Outline the medical management of status asthmaticus or severe acute asthma exacerbation across the continuum of care, as the patient transitions from the ED to the PICU.</li>\r\n    <li>Describe respiratory support strategies to manage the airway needs of a pediatric patient with severe acute asthma exacerbation or status asthmaticus.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE Credit",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5ECE2477-B77B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                        "course_category_name": "Infant Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B7DCC91F-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4499E302-2F51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5A34B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Respiratory Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "Review details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 1.00] [CRCE Credits: 1.00]",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];